<script setup lang="ts">
defineProps<{
  rows?: 4
}>()
</script>

<template>
  <V2Card
    as="ul"
    :class="[
      'v2-list grid gap-x-3',
      rows ? `v2-list-grid v2-list-grid-${rows}` : null,
    ]"
  >
    <slot/>
  </V2Card>
</template>

<style lang="scss">
.v2-list {
  & > * {
    &::after {
      border-bottom: 1px solid #e4eaf1;
      clear: both;
      content: "";
      display: block;
      margin-bottom: 4px;
      margin-top: 4px;
    }

    &:last-of-type {
      &::after {
        clear: none;
        display: none;
      }
    }
  }

  &.v2-list-grid {
    grid-auto-flow: column;
    padding-bottom: 4px;

    &.v2-list-grid-4 {
      grid-template-rows: repeat(4, minmax(0, 1fr));

      & > * {
        &:nth-of-type(4n) {
          &::after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
